
interface HeroProps {
  onApplyClick: () => void;
}

export default function Hero({ onApplyClick }: HeroProps) {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/93d1b6db5595053eb5740c13c533439f.jpg')`
      }}
    >
      <div className="container mx-auto px-6 py-20 text-center relative z-10">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight">
          Starte jetzt als freiberuflicher Partner
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-12 max-w-3xl mx-auto leading-relaxed">
          Digitale Zukunft im Sport aktiv mitgestalten – mit Community, massentauglichem Produkt und Echtzeit-Provisionen.
        </p>
        <button 
          onClick={onApplyClick}
          className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white text-lg font-semibold px-10 py-5 rounded-full transition-all duration-300 shadow-2xl hover:shadow-blue-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          <span>👉</span>
          <span>Jetzt als Partner bewerben</span>
        </button>
      </div>
    </section>
  );
}
